module.exports = __webpack_public_path__ + "static/img/passion-thumb.68224e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-thumb.jpg
// module id = 38
// module chunks = 0